import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Pages
const LandingPage = lazy(() => import('./pages/LandingPage'));
const UploadPage = lazy(() => import('./pages/UploadPage'));
const TemplatesPage = lazy(() => import('./pages/TemplatesPage'));
const CustomizationPage = lazy(() => import('./pages/CustomizationPage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const BlogPage = lazy(() => import('./pages/BlogPage'));
const ToolsPage = lazy(() => import('./pages/ToolsPage'));
const EyedropperTool = lazy(() => import('./pages/EyedropperTool'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

// Components
import { Toaster } from './components/ui/sonner';
import { ConsentBanner } from './components/ConsentBanner';

// Styles
import './App.css';
import './index.css';

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="fixed bottom-3 left-1/2 -translate-x-1/2 z-[80] rounded-full border border-border bg-background/95 px-3 py-1.5 text-[11px] text-muted-foreground shadow-lg backdrop-blur-sm md:hidden">
          For a better experience, switch to desktop view.
        </div>
        <Suspense
          fallback={
            <div className="min-h-screen flex items-center justify-center text-muted-foreground">
              Loading...
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/upload" element={<UploadPage />} />
            <Route path="/templates" element={<TemplatesPage />} />
            <Route path="/customize" element={<CustomizationPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/eyedropper" element={<EyedropperTool />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>

      <ConsentBanner />
      <Toaster position="top-center" richColors />
    </div>
  );
}
